export default "__VITE_ASSET__7wTujyZa__"